export default __webpack_public_path__ + "static/media/köide-26-27.72134769.png";